import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {BusinessService} from '@mpt-fo/common/core/services/business.service';
import {KycService} from '@mpt-fo/common/core/services/kyc-service';
import {LocalStorageService} from '@mpt-fo/common/core/services/local-storage.service';
import {MobileDelegateService} from '@mpt-fo/common/core/services/mobile-delegate.service';
import {MobileWebViewService} from '@mpt-fo/common/core/services/mobile-web-view.service';
import {ModalHelperService} from '@mpt-fo/common/core/services/modal-helper.service';
import {OnboardingService} from '@mpt-fo/common/core/services/onboarding.service';
import {ScreenManagerService} from '@mpt-fo/common/core/services/screen-manager.service';
import {UtilityService} from '@mpt-fo/common/core/services/utility.service';
import {ModalService} from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import {MOBILE_CONTENT_MIN_HEIGHT} from '@mpt-fo/common/shared/constants';

import {OtpPinCreationComponent} from '../../otp-pin-creation.component';
import {ProfileService} from '@mpt-fo/common/core/services/profile.service';
import { AppConfig } from '@mpt-fo/common/shared/config/app-config';

@Component({
	selector: 'app-otp-pin-creation-mobile',
	templateUrl: './otp-pin-creation-mobile.component.html',
	styleUrls: ['./otp-pin-creation-mobile.component.scss']
})
export class OtpPinCreationMobileComponent extends OtpPinCreationComponent implements OnInit {
	contentHeight = MOBILE_CONTENT_MIN_HEIGHT;

	constructor(
		mobileService: MobileWebViewService,
		onboardingService: OnboardingService,
		modalService: ModalService,
		modalHelper: ModalHelperService,
		delegateService: MobileDelegateService,
		utilityService: UtilityService,
		screenManagerService: ScreenManagerService,
		router: Router,
		kycService: KycService,
		fb: FormBuilder,
		businessService: BusinessService,
		localStorage: LocalStorageService,
		profileService: ProfileService,
		config: AppConfig) {
		super(mobileService, onboardingService,
			modalService, modalHelper, delegateService,
			utilityService, screenManagerService,
			router, kycService, fb,
			businessService, localStorage, profileService, config);
	}

	ngOnInit(): void {
		this.initialize()
			.then(() => {
				this.loading = false;
			})
			.catch(error => {
				this.handleError(error);
				this.loading = false;
			});
	}

}
